import { PayloadAction, createSlice, current } from "@reduxjs/toolkit";

export type TriggerStatusTypes = "ENABLE" | "DISABLE" | "ON_GOING";
export type TriggerValueType = { data?: any; status: TriggerStatusTypes };

export type TriggerKeysType =
  | "default_trigger"
  | "pin_profile"
  | "hide_parital_checkbox"
  | "check_EMR_form_field_validity"
  | "submit_final_emr";

export type ITriggerReducerState = {
  [key in TriggerKeysType]: TriggerValueType;
};

const initialTriggerReducerState: ITriggerReducerState = {
  default_trigger: { status: "DISABLE" },
  pin_profile: { status: "DISABLE" },
  check_EMR_form_field_validity: { status: "DISABLE" },
  hide_parital_checkbox: { status: "DISABLE" },
  submit_final_emr: { status: "DISABLE" },
};

export const triggerStateSlice = createSlice({
  name: "trigger_slice",
  initialState: initialTriggerReducerState,
  reducers: {
    RESET_TRIGGERS: () => {
      return initialTriggerReducerState;
    },
    setTriggerStatus: (state, action: PayloadAction<{ trigger: TriggerKeysType; status: TriggerStatusTypes }>) => {
      state[action.payload.trigger].status = action.payload.status;
    },
    setTriggerData: (state, action: PayloadAction<{ trigger: TriggerKeysType; data: any }>) => {
      state[action.payload.trigger].data = action.payload.data;
    },
    togglerTriggerStatus: (state, action: PayloadAction<TriggerKeysType>) => {
      const trigger = current(state[action.payload]);
      state[action.payload].status = trigger.status === "DISABLE" ? "ENABLE" : "DISABLE";
    },
  },
});

export const { RESET_TRIGGERS, setTriggerData, setTriggerStatus, togglerTriggerStatus } = triggerStateSlice.actions;
export default triggerStateSlice.reducer;
